import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { xor } from "lodash";
import VariantPromptPopup from "../variants/VariantPromptPopup";
import { buildTwoTapPopupStylesheet } from "./VariantTwoTapPopupStyleResolver";

const VariantTwoTapPopup = (props) => {
  const variant = props.variant;
  const stylesheet = buildTwoTapPopupStylesheet(
    props.builder,
    props.device,
    props.cta,
    variant
  );

  if (props.builder == true) {
    useEffect(() => {
      ctas.builder.fonts.load_used_fonts(".cf-two-tap");
    }, [variant.options["prehook-button-font"]]);
  }

  if (
    variant.options["trigger_type"] === "prompt" ||
    (variant.options["prehook-trigger-on-close"] == "true" &&
      variant.options["close-message-type"] == "prompt")
  ) {
    let messages = [];
    const rawMessages = variant.options["prompt-messages"];
    if (Array.isArray(rawMessages)) {
      messages = rawMessages;
    } else if (rawMessages && typeof rawMessages === "object") {
      messages = Object.values(rawMessages);
    } else {
      try {
        messages = JSON.parse(rawMessages || "[]");
      } catch (e) {
        messages = [];
      }
    }
    if (messages && !Array.isArray(messages) && typeof messages === "object") {
      messages = Object.values(messages);
    }
    messages = (Array.isArray(messages) ? messages : []).map((message) =>
      typeof message === "string" ? { text: message } : message
    );
    return <VariantPromptPopup {...props} messages={messages} />;
  }

  return (
    <React.Fragment>
      {variant.options["trigger_type"] !== "prehook" && (
        <VariantTwoTapPopupButton {...props} />
      )}
      {variant.options["trigger_type"] == "prehook" && (
        // prehook is what we called two-tap popups back in the day
        <VariantTwoTapPopupProfile {...props} />
      )}
      <style dangerouslySetInnerHTML={{ __html: stylesheet }} />
    </React.Fragment>
  );
};

const VariantTwoTapPopupButton = (props) => {
  const variant = props.variant;

  return (
    <React.Fragment>
      <div className="cf-two-tap-close">
        <svg
          fill={
            variant.options["prehook-button-font-color"]
              ? variant.options["prehook-button-font-color"]
              : "#fff"
          }
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 30 30"
        >
          <path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z" />
        </svg>
      </div>
      <div
        className="cf-two-tap-message"
        data-font={variant.options["prehook-button-font"]}
        style={{
          fontFamily: variant.options["prehook-button-font"],
        }}
        dangerouslySetInnerHTML={{
          __html: variant.options["prehook-message"]
            ? variant.options["prehook-message"]
            : "<p>Your message here</p>",
        }}
      ></div>
    </React.Fragment>
  );
};

const VariantTwoTapPopupProfile = (props) => {
  const variant = props.variant;
  const user = props.user;

  let profile_brand = props.website.brand ? props.website.brand : "";
  let profile_avatar =
    user && user.avatar
      ? user.avatar
      : "https://img.convertflow.co/static/avatar.jpg";

  let profile_name;
  if (user && user.name) {
    profile_name = user.name + (user.lastname ? " " + user.lastname : "");
  } else {
    profile_name = "A team member";
  }
  return (
    <React.Fragment>
      <div
        id="trigger-prehook"
        className="cf-col-xs-12 prehook-message"
        style={{ padding: "25px 20px 15px" }}
        dangerouslySetInnerHTML={{
          __html: variant.options["prehook-message"]
            ? variant.options["prehook-message"]
            : "<p>Your message here</p>",
        }}
      ></div>
      <div
        className="cf-col-xs-2 cf-center"
        style={{ paddingBottom: props.builder == true ? "10px" : undefined }}
      >
        <div className="prehook-profile cf-profile-img" id="prehook-profile">
          <img src={profile_avatar} />
        </div>
      </div>
      <div className="cf-col-xs-6" style={{ padding: "10px 0px 0px 10px" }}>
        <div className="prehook-name">
          <p className="cf-profile-name">{profile_name}</p>
        </div>
        <div className="prehook-title">
          <p>
            <span className="cf-profile-title">{profile_brand}</span>
          </p>
        </div>
      </div>
      <div
        id="trigger-cta"
        className="cf-prehook-button cf-button-primary cf-center"
        style={{
          background: variant.options["prehook-button-color"],
        }}
        dangerouslySetInnerHTML={{
          __html: variant.options["prehook-cta"]
            ? variant.options["prehook-cta"]
            : "<p>See More</p>",
        }}
      ></div>
      <div className="prehook-close">x</div>
    </React.Fragment>
  );
};

export default VariantTwoTapPopup;
